import Vue from "vue"
import PhaseNewContract from "../phases/phase-new-contract.vue"
import PhaseContractConfirmation from "../phases/phase-contract-confirmation.vue"

import { ContractPageBase } from "../../Default/ContractPage/contract-page"
import SessionExpiration from "../../Default/common/session-expiration.vue";

import BootstrapVue from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)

export class ContractPage extends ContractPageBase {
    constructor(rootSelector: string) {
        super(rootSelector,
            [
                { name: "phase-new-contract", id: 1 },
                { name: "phase-confirmation", id: 2 },
            ],
            { PhaseNewContract, PhaseContractConfirmation, SessionExpiration }
        );
    }
}

const page = new ContractPage("#rootContainer");